// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__17XR6","list":"BalanceDue_list__3cm0c","listRow":"BalanceDue_listRow__1zC0m","total":"BalanceDue_total__CaOCN"};